import { render, staticRenderFns } from "./petSolution.vue?vue&type=template&id=049284ea&scoped=true"
import script from "./petSolution.vue?vue&type=script&lang=js"
export * from "./petSolution.vue?vue&type=script&lang=js"
import style0 from "./petSolution.vue?vue&type=style&index=0&id=049284ea&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049284ea",
  null
  
)

export default component.exports